'use strict';

jQuery(document).ready(function ($) {
	'use strict';

	// Sticky sidebar

	$('#sticker').sticky({
		topSpacing: $('#stickynav').outerHeight() + 30,
		bottomSpacing: $(document).height() - ($('#header').outerHeight() + $('#main-content').outerHeight()) + 60
	});

	// Galerija 
	var $fancybox = $('a.fancybox');
	if ($fancybox.length) {
		$('a.fancybox').fancybox({
			'transitionIn': 'elastic',
			'transitionOut': 'elastic',
			'speedIn': 600,
			'speedOut': 200,
			'overlayShow': false,
			'padding': 0,
			'margin': 10
		});
	}

	// Lazy load background image, ako je samo jedna na elementu
	// <div class="lazyload" data-bg="<?php echo get_template_directory_uri(); ?>/assets/img/slika.jpg">
	document.addEventListener('lazybeforeunveil', function (e) {
		var bg = e.target.getAttribute('data-bg');
		if (bg) {
			e.target.style.backgroundImage = 'url(' + bg + ')';
		}
	});

	// --- Animacije --- ručno sve jer su bile svakakve promjene.. a kaj buš
	// O nama 
	var $povijest_img = $('.povijest__inside');
	// Ostale stranice koje imaju sliku ispod teksta
	var $page_img = $('.outside').find('img');
	// Stranica vina
	var $page_vina1_img = $('.bijela-vina-wrapper').find('img');
	// Stranica vina
	var $page_vina2_img = $('.pjenusava-vina-wrapper').find('img');
	// Stranica vina
	var $page_vina3_img = $('.crvena-vina-wrapper').find('img');
	// Stranica vina
	var $page_vina3_img = $('.crvena-vina-wrapper').find('img');
	// Stranica vina
	var $page_vina4_img = $('.predikatna-vina-wrapper').find('img');
	// Vinogradi - karta
	var $page_vinogradi_img = $('.vinogradi__karta').find('img');
	// Single vino - stranica
	var $page_vino_img = $('.single-vino__img').find('img');

	$(window).scroll(function () {

		// O nama
		if ($povijest_img.is(':in-viewport')) {
			$povijest_img.addClass('appeared');
		}

		// Ostale stranice koje imaju sliku ispod teksta
		$page_img.each(function () {
			var $this = $(this);
			if ($this.is(':in-viewport')) {
				$this.addClass('appeared');
			}
		});

		// Stranica vina
		$page_vina1_img.each(function () {
			if ($page_vina1_img.is(':in-viewport')) {
				$page_vina1_img.addClass('appeared');
			}
		});
		$page_vina2_img.each(function () {
			if ($page_vina2_img.is(':in-viewport')) {
				$page_vina2_img.addClass('appeared');
			}
		});
		$page_vina3_img.each(function () {
			if ($page_vina3_img.is(':in-viewport')) {
				$page_vina3_img.addClass('appeared');
			}
		});
		$page_vina4_img.each(function () {
			if ($page_vina4_img.is(':in-viewport')) {
				$page_vina4_img.addClass('appeared');
			}
		});

		// Vinogradi - karta
		if ($page_vinogradi_img.is(':in-viewport')) {
			$page_vinogradi_img.addClass('appeared');
		}

		// Single vino - stranica
		if ($page_vino_img.is(':in-viewport')) {
			$page_vino_img.addClass('appeared');
		}
	});

	// Provjeri odmah
	// Single vino - stranica
	if ($page_vino_img.is(':in-viewport')) {
		$page_vino_img.addClass('appeared');
	}

	// Scroll to top gumbić u footeru
	$(window).scroll(function () {
		if ($(this).scrollTop() > 400) {
			$('.scrollToTop').addClass('active');
		} else {
			$('.scrollToTop').removeClass('active');
		}
	});
	$('.scrollToTop').click(function () {
		$('html, body').animate({ scrollTop: 0 }, 800);
		return false;
	});

	// Prikaži navigaciju samo kada se zaskrola prema gore
	var previousScroll = 0;
	var $navbar = $('.navbar');
	var currentScroll = 0;
	$(window).scroll(function () {
		currentScroll = $(this).scrollTop();

		if (function (currentScroll) {
			return 220 && currentScroll < $(document).height() - $(window).height();
		}) {
			// Ako se skrola prema dolje
			if (currentScroll > previousScroll) window.setTimeout(hideNav, 300);
			// Ako se skrola prema gore
			else window.setTimeout(showNav, 300);
			previousScroll = currentScroll;
		}
		function hideNav() {
			$('[data-nav-status=\'toggle\']').removeClass('is-visible').addClass('is-hidden');
		}
		function showNav() {
			$('[data-nav-status=\'toggle\']').removeClass('is-hidden').addClass('is-visible');
		}
	});

	// Cookie notice settings
	if (Cookies.get('cookie-notice') !== 'Accepted') {
		var $cookieWrapper = $('#bideja-cookie-notice');
		var $cookieBtn = $cookieWrapper.find('#accept-cookie');
		$cookieWrapper.removeClass('bi-remove');
		$cookieBtn.click(function () {
			// Expire je na 5 godina
			Cookies.set('cookie-notice', 'Accepted', { expires: 365 * 5 });
			// Makni fadeanjem
			$cookieWrapper.fadeOut(300, function () {
				$(this).remove();
			});
		});
	}

	// Parallax za naslovnu sliku
	$(window).scroll(function () {
		var x = $(this).scrollTop();
		var onama_js = $('.onama_js');
		if (onama_js.length) {
			onama_js.find('.header-wrapper--page').css('background-position-y', parseInt(-x / 2) - 70 + 'px');
		} else {
			$('.header-wrapper--page').css('background-position-y', parseInt(-x / 2) + 'px');
		}
	});
});
// Lazy load carousel slike
jQuery(window).load(function () {

	jQuery('#slider .item').each(function () {
		var src = $(this).data('src');
		$(this).css('background-image', 'url(' + src + ')');
	});

	// Animacija - Početna slider
	var $slider = $('#slider');
	$slider.find('.item').addClass('appeared');
});